
import env from '@/api/env';
import store from '@/store/index';
import axios from 'axios';
import auth from '@/api/auth';
import { strings } from "@/plugins/strings";
import papi from '@/api/papi';


export default {

	async init() {
		this.jwt = await auth.getCredentials();
	},


	async call(caller, username, isVoiceCall, to, sysid) {

		let response;

		if (papi.isCamelot) {
			response = await this.post(`https://api${env.suffix()}.k4connect.com/v4/service/calls/call`, { to, isVoiceCall }, { headers: { authorization: `Bearer ${this.jwt}` } });
		} else {
			response = await this.post(`${env.content()}/call`, { caller, username, isVoiceCall, to, sysid, credentials: { password: this.jwt, guid: username } });
		}

		return response.data;
	},

	async cancel(user, apiKey, sessionId, token, declined, cancelled, hungup) {

		const users = [user];
		const message = { ...(declined && { declined }), ...(cancelled && { cancelled }), ...(hungup && { hungup }), call: { apiKey, sessionId, token } };
		const guid = store.getters['user/id'];

		let response;

		if (papi.isCamelot) {
			response = await this.post(`https://api${env.suffix()}.k4connect.com/v4/service/calls/notify`, { recipient: user, body: message }, { headers: { authorization: `Bearer ${this.jwt}` } });
		} else {
			response = await this.post(`${env.sso()}/notify`, { users, message, credentials: { password: this.jwt, guid } });
		}
		
		return response.data;
	},

	async post(url, body, options = {}) {
		let response;

		try {
			if (papi.isCamelot) {
				response = await axios.post(url, body, options);
			} else {
				response = await axios.post(url, body);
			}
		} catch (e) {
			console.log(e)
			if (e.message.toLowerCase().includes("network error")) {
				store.dispatch("alerts/error", strings.errors.internet.offline);
			}
			throw e;
		}
		return response;

	},

}
